/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_H2Inputs */

const en_diff_ref_h2 = /** @type {(inputs: Diff_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meaning`)
};

const ko_diff_ref_h2 = /** @type {(inputs: Diff_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의미`)
};

const ja_diff_ref_h2 = /** @type {(inputs: Diff_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味`)
};

/**
* | output |
* | --- |
* | "Meaning" |
*
* @param {Diff_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_h2 = /** @type {((inputs?: Diff_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_h2(inputs)
	if (locale === "ko") return ko_diff_ref_h2(inputs)
	return ja_diff_ref_h2(inputs)
});